import PropTypes from 'prop-types';
import React from 'react';
import {
  getTranslation,
  Icon,
  Link,
  Spacer,
  TranslationProvider,
} from '@resy/ui-kitchen';
import OPENAI_WIDGET from '../../constants/srcTypes';

import ResyLogo from '../../svg/resy-logo.svg';

import './DownloadResy.scss';

const OS = { android: 'android', ios: 'ios' };
const appleUrl = 'https://itunes.apple.com/app/apple-store/id866163372?pt=86835890&ct=widget&mt=8';

const fireAnalyticsForOaiWidget = (sourceId) => {
  if (sourceId === OPENAI_WIDGET) {
    window?.parent?.postMessage({ name: 'resy-external', link: appleUrl }, '*');
  }
};

const getDownloadImage = (os, language) => (
  `https://s3.amazonaws.com/resy.com/images/download/download_${os}_${language.toLowerCase()}.svg`
);

const DownloadResy = ({ language, sourceId }) => (
  <div className="DownloadResy">
    <Icon
      component={ResyLogo}
      name="resy-logo"
      role="img"
      ariaLabel={getTranslation({ translationKey: 'resy_logo_right_this_way', fallback: 'Resy logo, right this way' })}
    />
    <Spacer height="20" />
    <div className="DownloadResy__copy1">
      <TranslationProvider translationKey="download_resy_title">
        <span>Manage your reservation with ease.</span>
      </TranslationProvider>
    </div>
    <div className="DownloadResy__copy2">
      <TranslationProvider translationKey="download_resy_description">
        <span>Download Resy to easily make changes, cancel, add a special occasion, and log your dining preferences.</span>
      </TranslationProvider>
    </div>
    <Spacer height="20" />
    <div className="DownloadResy_ctas">
      <Link
        aria-label={getTranslation({ translationKey: 'click_to_download_ios_app', fallback: 'Click to download Resy App from Apple App Store' })}
        href={appleUrl}
        onClick={() => fireAnalyticsForOaiWidget(sourceId)}
        target="_blank"
      >
        <img alt="" src={getDownloadImage(OS.ios, language)} />
      </Link>
    </div>
  </div>
);

DownloadResy.propTypes = {
  language: PropTypes.string.isRequired,
  sourceId: PropTypes.string,
};

DownloadResy.defaultProps = {
  sourceId: undefined,
};

export default DownloadResy;
